export enum VehicleClass {
    KLEINSTWAGEN = 5,
    KLEINWAGEN = 6,
    KOMPAKTWAGEN = 7,
    MITTELKLASSE = 8,
    OBERKLASSE = 9,
    NUTZFAHRZEUG = 10,
}
